{
	"title": "Transações em conciliação",
	"filterByLabel": "Filtrar por",
	"filterByPlaceholder": "Selecione o filtro",
	"filterOptions": {
		"paymentMethod": "Método de Pagamento",
		"paymentMethodCredit": "Crédito",
		"paymentMethodDebit": "Débito",
		"vendor": "Vendor",
		"status": "Status"
	},
	"searchPlaceholder": "Buscar por...",
	"columns": {
		"transactionDate": "DATA DA TRANSAÇÃO",
		"paymentMethod": "MÉTODO DE PAGAMENTO",
		"vendor": "VENDOR",
		"terminalNumber": "N.° DO TERMINAL",
		"status": "STATUS",
		"value": "VALOR",
		"receipt": "COMPROVANTE"
	},
	"statusPending": "PENDENTE",
	"statusProcessed": "PROCESSADA",
	"statusReconciled": "CONCILIADA",
	"statusCancelled": "CANCELADA",
	"statusTooltipPaid": "Transação já paga na adquirente",
	"receiptTooltipView": "Ver comprovante",
	"receiptTooltipUnavailable": "Comprovante indisponível",
	"of": "de",
	"backButton": "Voltar"
}
